var site = window.site || {};

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " + extraClasses + "'></div>");
	}
}

site.nav = {
	// Init navigation scripts
	init: function () {
		// Add expand link to mobile menu
		$('.children', '#mainmenu ').prepend('<span class="expand" href="#"><i class="fa fa-angle-down"></span>');
		$('.selectedLevel1','#mainmenu').addClass('down');
		$('.selectedLevel2','#mainmenu').addClass('down');

		var $menu = $('#mainmenu');

		site.nav.bind();
		site.nav.appendLanguage();
	},
	bind: function () {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function (e) {
			var menuOpen = $('body').hasClass('mainmenu-open');
			if (!menuOpen) {
				site.window.scrollPosition = $(window).scrollTop();
			}
			site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);

			e.preventDefault();
		});

		// Expand in mobile menu
		$('.expand', '#mainmenu').bind('click', function (e) {
			$(this).closest('li').toggleClass('down');
			e.preventDefault();
		});
	},
	// Toggle mobile menu
	mobileToggle: function (e, menuOpen, scrollPosition) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
		if (!menuOpen) {
			$(window).scrollTop(0);
		}
		else {
			$(window).scrollTop(scrollPosition);
		}
	},
	// Append language to mobilemenu
	appendLanguage: function () {
		var $divisions = $('#header .cats .menu');
		var $social = $('#header .social');
		var $menu = $('ul.mmLevel1', '#mainmenu');
		var $tmp = $($divisions.clone().html());
		$menu.append($tmp);
		$('#mainmenu').prepend($social.clone());
		/*
		var $html = $('<li class="ele-cats si level1"></li>');

		$divisions.find('li').each(function () {
			var $li = $(this).clone();
			$menu.append('<li class="ele-cats level1">'+$li.find('a')+'</li>');
		});

		$menu.append($html);*/
	}
};

site.header = {
	init: function() {
		var body = $('body');
		$(window).scroll(function(e) {
			scrollPos = $(this).scrollTop();
			if(scrollPos > 66) {
				body.addClass('stickyHead');
			}
			else {
				body.removeClass('stickyHead');
			}
		});
	}
};

site.news = {
	init: function() {
		//load more button
		$news = $('.frontNews #news');
		$newsCount = $news.find('.entries .entry').length;
		if($newsCount < 8) {
			$news.find('.entriesFooter').addClass('hide');
		}
		$(document).on('click', '#loadMore', function(e) {
			var $parent = $('#news .entries');
			$(this).parents('.footer').addClass('loading');
			var cat = $parent.data('cat');
			var offset = $parent.data('offset');

			site.news.loadNews([cat,offset]);
			e.preventDefault();
		});

		if($('body').hasClass('magazineView')) {
			site.news.imgMove();
		}
		if($('body').hasClass('frontNews')) {
			site.news.fixMenu();
		}
	},
	loadNews: function(options) {
		var $parent = $('#news .entries');
		var cat = options[0];
		var offset = (options[1]) ? options[1] : 1;
		if (offset == 1) {
			/*$('#news .entries').empty();*/
		}
		$.ajax({
			url: '/_/magazine/newsHtml/index/news/'+cat+'/'+offset,
			dataType: 'json',
			success: function(r) {
				$.each(r.categories, function(i,c) {
					$parent.append(c.data);

					if(c.more) {
						$parent.data("offset",offset + 1);
						$parent.find('.footer').removeClass('loading');
					}
					else {
						$('#news .entriesFooter').addClass('hide');
					}
				});
				setTimeout(function() {
					$('#news .entry.loading').addClass('loaded').removeClass('loading');
					$('#news .entry.loaded .entryImage img').responsiveImg();
					$('html,body').animate({
						scrollTop: $(window).scrollTop() + 540
					});
				},10);
			}
		});
	},
	imgMove: function() {
		/*
		var body = $('body');
		var $img = $('#news .entryImage.trans');
		*/
		var $newsText = $('#news .newsText');
		var titleTop = -$newsText.find('.extraTitle').outerHeight(true)-12;
		$newsText.css('margin-top',titleTop);
		/*
		var titlePos = $newsText.offset().top;
		var lastScroll = 0;
		var moveBy = $img.height();
		*/
		/*
		$(window).on('load',function() {
			scrollPos = $(this).scrollTop();
			$(window).scroll(function(e) {
				if(lastScroll < scrollPos && scrollPos > (titlePos - 300)) {
					$img.find('img').stop().animate({
						bottom:moveBy
					},500,'swing',function() {
						body.addClass('titleScroll');
					});
				}
				if(lastScroll > scrollPos && scrollPos < (titlePos)) {
					$img.find('img').stop().animate({
						bottom:0
					},400,'swing',function() {
						body.removeClass('titleScroll');
					});
				}
				lastScroll = scrollPos;
			});
		});
		*/
	},
	fixMenu: function() {
		var catCodename = $('body').attr('class').split(' ').pop();
		$('#header .cats li.'+catCodename).addClass('selectedLevel1');
		$('#mainmenu li.'+catCodename).addClass('selectedLevel1');
	},
	titleMove: function() {
		var body = $('body');
		var $newsText = $('#news .newsText');
		var titleTop = -$newsText.find('.extraTitle').outerHeight(true)-12;
		$newsText.css('margin-top',titleTop);
		$(window).on('load',function() {
			var titlePos = $newsText.offset().top;
			var titlePos2 = titlePos;
			var titleTop = -$newsText.find('.extraTitle').outerHeight(true)-12;
			var titleTop2 = titleTop;
			var lastScroll = 0;

			$(window).scroll(function(e) {
				scrollPos = $(this).scrollTop();
				if(scrollPos > titlePos && lastScroll < scrollPos && titleTop < 1) {
					var moveBy = scrollPos - titlePos;
					titleTop = titleTop + moveBy;
					titleTop = (titleTop > 0) ? 0 : titleTop;
					$newsText.stop().animate({
						marginTop:titleTop
					},400,'swing',function() {
						titlePos = $newsText.offset().top;
					});
				}
				lastScroll = scrollPos;
				/*
				if scrollPos er stærri en titlePos þá scrolla texta niður þangað til 0

				if(scrollPos > titlePos && scrollPos > lastScroll && titleTop2 < 0) {
					$newsText.stop().animate({
						marginTop:0
					},400,'swing',function() {
						body.addClass('titleScroll');
						titlePos = $title.offset().top;
						titleTop2 = 0;
					});
				}
				if(titleTop2 == 0 && (scrollPos < (titlePos - 200)) && scrollPos < lastScroll) {
					$newsText.stop().animate({
						marginTop:titleTop
					},400,'swing',function() {
						body.removeClass('titleScroll');
						titlePos = titlePos2;
						titleTop2 = titleTop;
					});
				}
				lastScroll = scrollPos;
				*/
			});

		});
	}
};

// Run all the inits \o/
$(function () {
	site.nav.init();
	site.header.init();
	site.news.init();

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').bind('click', function (e) {
		e.preventDefault();
		window.location = '/moya';
	});
	$('.bottomNewsletter').click(function(e) {
		location.href = $(this).find('a.more').attr('href');
	});

	$('#news .newsSidebar .share .shareOpen').click(function(e) {
		e.preventDefault();
		$(this).parent().toggleClass('open');
	});
});
